<template>
  <div class="member-area-comments-profile">
    <div class="my-9 text-center" v-if="loading">
      <b-spinner variant="primary" />
    </div>

    <div class="component-content" v-else>
      <div class="content">
        <step-title
          class="mb-5"
          icon="fa fa-info"
          title="Perfil moderador"
          description="Preencha com informações para que o seus alunos saibam que você está interagindo com eles."
        />

        <form-group
          id="name"
          class="pb-2"
          v-model="form.name"
          required
          label="Nome do perfil"
          placeholder="Ex. Professor Rodrigo"
        />
        <div class="fs-12 mb-6">
          Nome que aparece do lado da foto de perfil. Importante: caso esse
          campo esteja vazio, iremos exibir o nome do produto durante suas
          interações com os alunos.
        </div>
      </div>
      <div class="profile-picture">
        <input-image
          id="photo"
          v-model="form.photo"
          title="Foto do perfil"
          dimensions="200px x 200px"
          description="Foto que o identifique como moderador. Importante: caso você não faça o upload de uma imagem, iremos exibir as iniciais do produto durante suas interações com os alunos."
        />
      </div>
      <div class="buttons d-flex justify-content-between mt-6">
        <button class="btn btn-outline-secondary px-6">
          Cancelar
        </button>
        <button
          class="btn btn-primary px-6"
          :disabled="!isValid"
          @click="submit"
        >
          Salvar
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { formFields } from "@/functions/helpers";

export default {
  data() {
    const product_id = this.$store.state.product?.product?.id;
    return {
      ...formFields(["code", "name", "photo", "product_id"]),
      product_id,
      loading: false
    };
  },
  computed: {
    isValid() {
      return !!this.form.name;
    }
  },
  methods: {
    submit() {
      const action = this.form.code
        ? "putModeratorProfile"
        : "postModeratorProfile";
      this.$store
        .dispatch(`membersComments/${action}`, {
          ...this.form,
          product_id: this.product_id
        })
        .then(() => this.$message.success("Perfil salvo"))
        .catch(() => {
          this.$message.error("Erro ao salvar perfil");
        });
    }
  },
  mounted() {
    if (this.product_id) {
      this.loading = true;
      this.$store
        .dispatch("membersComments/getModeratorProfiles", this.product_id)
        .then(({ data: { results } }) => {
          if (results[0]) this.form = { ...this.form, ...results[0] };
        })
        .finally(() => (this.loading = false));
    }
  }
};
</script>
<style lang="scss" scoped>
.member-area-comments-profile {
  .component-content {
    @media screen and (min-width: 992px) {
      .profile-picture {
        grid-area: a;
        border-right: 1px solid rgba(219, 221, 230, 0.85);
      }
      .content {
        grid-area: b;
      }
      .buttons {
        grid-area: c;
      }
      display: grid;
      grid-template-columns: 1fr 3fr;
      grid-template-rows: 1fr auto;
      gap: 16px;

      grid-template-areas:
        "a b"
        "a c";
    }
  }
}
</style>
